import script from "./BaseGuard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseGuard.vue?vue&type=script&setup=true&lang=ts"

import "./BaseGuard.vue?vue&type=style&index=0&id=ddc6a7a0&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddc6a7a0"]])

export default __exports__